/*
 * Copyright (c) Arbeidskracht Groep B.V. - all rights reserved
 */

import React, {ReactNode} from 'react';
import styles from './styles';
import {css} from 'aphrodite/no-important';
import { SpinnerRoundOutlined } from 'spinners-react';

class CenteredSpinner extends React.Component {

	render(): ReactNode {
		return (
			<div className={css(styles.loaderContainer)}>
				<div className={css(styles.loader)}>
					<SpinnerRoundOutlined size={90} color={'#337ab7'}/>
				</div>
			</div>
		);
	}
}

export default CenteredSpinner;
